module.exports = __webpack_public_path__ + "fonts/IBMPlexSans-SemiBold.e077582a.ttf";